import styled from 'styled-components'
import Colors from 'constants/colors'
import Threshold from 'constants/threshold'

export const ContactsContainerStyled = styled.div`
  padding-right: 25px;
  max-width: 1055px;
  @media (min-width: ${Threshold.phone}) {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 45px;
  }
`

export const ContactItemStyled = styled.div<{
  index?: number
}>`
  display: flex;
  align-items: center;
  margin-bottom: 40px;
  position: relative;

  img {
    clip-path: polygon(0 4%, 96% 0, 81% 96%, 0 78%);
    padding: 0;
  }

  div {
    padding-left: 23px;
  }

  &::after {
    content: '';

    position: absolute;
    left: 4px;
    top: 10px;
    z-index: -1;

    width: 133px;
    height: 146.71px;

    clip-path: polygon(0 4%, 96% 0, 81% 96%, 0 78%);

    background-color: ${props => (props.index % 2 === 0 ? Colors.blue : Colors.orange)};

    @media (max-width: 700px) {
      width: 100px;
      height: 110px;

      top: 6px;
      left: 2.5px;
    }
  }

  .contact {
    &__photo {
      box-sizing: initial;
      width: 100px;
      height: 110px;
      flex-shrink: 0;
      object-fit: cover;
    }
    &__name {
      font-weight: bold;
      font-size: 20px;
      line-height: 25px;
      color: ${Colors.black};
      margin-bottom: 10px;
    }
    &__position {
      margin-bottom: 5px;
    }
  }
  a {
    display: block;
    text-decoration: none;
    color: ${Colors.orange};
    margin-bottom: 5px;
    font-size: 14px;
    line-height: 22px;
    transition-duration: 0.2s;
  }
  p {
    font-size: 14px;
    line-height: 22px;
  }
  @media (min-width: ${Threshold.phone}) {
    width: 50%;
    margin-bottom: 45px;

    a:hover {
      text-decoration: underline;
    }

    .contact {
      &__photo {
        width: 133px;
        height: 146.71px;
      }
      &__position {
        font-size: 16px;
        line-height: 24px;
      }
    }
  }
`

export const PartnersGridStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 22px 0 23px;
  margin-bottom: 10px;
  .name {
    font-weight: bold;
    font-size: 14px;
    line-height: 22px;
    margin-bottom: 20px;
    text-align: center;
  }
  .grid {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    max-width: 1100px;
  }
  @media (min-width: ${Threshold.phone}) {
    margin-bottom: 30px;
    .name {
      font-size: 20px;
      line-height: 25px;
      margin-bottom: 30px;
    }
  }
`
export const PartnerStyled = styled.div<{
  index?: number
}>`
  text-decoration: none;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15);
  position: relative;
  width: 100px;
  height: 100px;
  overflow: hidden;
  background-color: #fff;
  margin: 0 5px 20px 5px;
  padding: 15px;

  &:hover {
    .logo {
      transform: scale(1.1);
    }
  }
  @media (min-width: ${Threshold.phone}) {
    width: ${props => (props.index < 2 ? '200px' : '160px')};
    height: ${props => (props.index < 2 ? '200px' : '160px')};
    margin: 0 10px 20px 10px;
    padding: 25px;
  }
`
export const PartnerLogoStyled = styled.div<{
  logoUrl?: string
}>`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #000;
  background: url(${({ logoUrl }) => logoUrl}) no-repeat center center;
  background-size: contain;
  margin-bottom: 10px;
  transition-duration: 0.2s;
`
